export const MOCK_MODE = import.meta.env.DEV && import.meta.env.MODE === 'mock';

export const disallowDomains = import.meta.env.VITE_DISALLOW_DOMAINS;

export const allowDomains = import.meta.env.VITE_ALLOW_DOMAINS;
